<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список населенных пунктов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить населенный пункт</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="mb-3">
            <label for="playlist-name" class="form-label">
                Название населенного пункта <span class="color-red">*</span>
            </label>
            <input type="text" class="form-control" id="playlist-name" v-model="formData.name" placeholder="Название">
        </div>

        <div class="mb-4">
            <div class="form-label">Регион <span class="color-red">*</span></div>
            <v-select
                :disabled="picked_client === 0 && client_id === 0"
                id="input_name_client_id"
                v-model="formData.region"
                :items="regions"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="create"/>
            <a class="btn btn-lg btn-grey btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import City from "../../../../models/City";
import Region from '../../../../models/Region';
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "CityCreateComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_create: String,
        route_regions: String
    },
    data: function () {
        return {
            city: new City({
                route_create: this.route_create
            }),
            region: new Region({
            route_list: this.route_regions,
            }),
            regions: [],
            formData: {
                name: '',
                region: null
            },
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        create: async function () {
            if (this.formData.name === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите название!' });
                this.toggleLoading();
                return;
            }
            if (!this.formData.region) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите регион!' });
                this.toggleLoading();
                return;
            }
            let result = await this.city.create(this.formData);
            if(result) {
                window.location.href = this.route_back;
            }
            else {
                console.log('error: create_city');
            }
        },
        getRegions: async function () {
            let response = await axios.get(this.route_regions, {params: {
                    page: 1,
                    limit: 50,
                }}).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список регионов, что-то пошло не так' });
                this.toggleLoading();
            });

            this.regions = response.data.items;
        },
        showError() {
            this.$refs.Error.showError()
        }
    },
    mounted() {
        this.getRegions();
    }
}
</script>

<style scoped>

</style>
